import React, { FC } from "react";
import "./tablePage.scss";
import TableHeader from "./TableHeader";
import Table, { TableProps } from "./Table";
import { TableCard } from "../../../common/types/tableCardType";
import { TableFiltersProps } from "./TableFilters";
import { CardsProps } from "./TableHeaderCards";
import { SortTableProps } from "./SortTable";

interface TablePageParams {
  headerHeadline?: string;
  customClass?: string;
  hideHeader?: boolean;
}
const TablePage = <T extends object>({
  trashAction,
  setFilters,
  filters,
  searchValue,
  setSearchValue,
  searchPlaceholder,
  buttonText,
  buttonAction,
  subButtonText,
  subAction,
  headerHeadline,
  tableHeadline,
  cards,
  setSortKey,
  sortKey,
  tableData,
  sortKeysArray,
  setSortOrder,
  sortOrder,
  filterObj,
  rowClick,
  EndRowIcon,
  deleteClick,
  DeleteRowIcon,
  dateFilter,
  customClass,
  hideHeader,
  toggleRowSelection,
  toggleSelectAll,
  allSelected,
  showCheckbox = false,
  selectedRows,
  searchAutoFocus,
}: TablePageParams &
  TableFiltersProps &
  CardsProps &
  Partial<SortTableProps> &
  TableProps<T> & {
    toggleRowSelection?: (index: number) => void;
    toggleSelectAll?: () => void;
    allSelected?: boolean;
    showCheckbox?: boolean;
    selectedRows?: string[];
    searchAutoFocus?: boolean;
  }) => {
  return (
    <div className={`table-page-main-container ${customClass || ""}`}>
      <div className="table-header">
        {!hideHeader && (
          <TableHeader
            headerHeadline={headerHeadline || ""}
            cards={cards || []}
          />
        )}
      </div>
      <div className="table-content">
        <Table
          searchAutoFocus={searchAutoFocus}
          dateFilter={dateFilter}
          rowClick={rowClick}
          filterObj={filterObj}
          setSortOrder={setSortOrder}
          sortOrder={sortOrder}
          tableHeadline={tableHeadline}
          trashAction={trashAction}
          setFilters={setFilters}
          filters={filters}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          searchPlaceholder={searchPlaceholder}
          buttonText={buttonText}
          buttonAction={buttonAction}
          subButtonText={subButtonText}
          subAction={subAction}
          tableData={tableData}
          setSortKey={setSortKey}
          sortKey={sortKey}
          sortKeysArray={sortKeysArray}
          EndRowIcon={EndRowIcon}
          deleteClick={deleteClick}
          DeleteRowIcon={DeleteRowIcon}
          toggleRowSelection={toggleRowSelection}
          toggleSelectAll={toggleSelectAll}
          allSelected={allSelected}
          showCheckbox={showCheckbox}
          selectedRows={selectedRows}
        />
      </div>
    </div>
  );
};

export default TablePage;
